function ThreeDotsIcon() {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="3"
                  height="12"
                  fill="none"
                  viewBox="0 0 3 12"
            >
                  <path
                        fill="#667085"
                        d="M1.333 9.333a1 1 0 110 2 1 1 0 010-2zm0-4.666a1 1 0 110 2 1 1 0 010-2zm0-4.667a1 1 0 110 2 1 1 0 010-2z"
                  ></path>
            </svg>
      );
}

export default ThreeDotsIcon;
